import React from 'react';
import { graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import ReactPlaceholder from 'react-placeholder';
import ReactPlayer from 'react-player';
import Popup from 'react-popup';

import PRODUCTION_DETAILS_QUERY from '../../../graphql/ProductionDetails';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import TheaterWidget from '../../Others/TheaterWidget';
import Carousel from '../../../components/Carousel/index';
import Button from '../../../components/Button/index';
import Ago from '../../../components/Ago/index';
import {
  ProductionUser,
  ProductionFeatures,
} from '../../../components/Production/index';
import SaleOrRent from '../../../components/SaleOrRent/index';
import Authorization from '../../../components/Authorization/index';
import Files from '../../../components/Files/index';
import ChangePlan from '../../../components/ChangePlan/index';
import Lock from '../../../components/Lock/index';
import IsGuest from '../../../utils/IsGuest';
import IsFreePlan from '../../../utils/IsFreePlan';
import ToggleProductionFavorite from '../../Others/ToggleProductionFavorite';
import { ADMIN_ROLE, THEATER_ADMIN_ROLE, FREE_PLAN } from '../../../constants';
import ContactTheaterForm from '../../Others/ContactTheaterForm';
import RecordTypeOptions from '../../../utils/selectors/RecordTypeOptions';
import SoundTypeOptions from '../../../utils/selectors/SoundTypeOptions';
import RoyaltyLengthOptions from '../../../utils/selectors/RoyaltyLengthOptions';
import NumberOfCamerasOptions from '../../../utils/selectors/NumberOfCamerasOptions';

class ProductionPage extends React.Component {
  getUserFeatures() {
    const { production } = this.props;

    if (production && {}.hasOwnProperty.call(production, 'features')) {
      return production.features.filter(feature => feature.type === 'user-text');
    }
    return [];
  }

  getLinks() {
    const { production } = this.props;

    if (production && {}.hasOwnProperty.call(production, 'features')) {
      return production.features.filter(feature => feature.type === 'link');
    }
    return [];
  }

  getVideos() {
    const { production } = this.props;

    if (production && {}.hasOwnProperty.call(production, 'features')) {
      return production.features.filter(feature => feature.type === 'video');
    }
    return [];
  }

  getBudget() {
    const { production } = this.props;

    switch (production.budget) {
      case 'f1':
        return 'Entre USD$0 y USD$15.000';
      case 'f2':
        return 'Entre USD$15.001 y USD$35.000';
      case 'f3':
        return 'Entre USD$35.001 y USD$50.000';
      case 'f4':
        return 'Entre USD$50.001 y USD$100.000';
      case 'f5':
        return 'Entre USD$100.001 y USD$400.000';
      case 'f6':
        return 'Más de USD$400.000';
      default:
        return 'Presupuesto no definido';
    }
  }

  getRights() {
    const { production } = this.props;

    switch (production.rights) {
      case 'yes':
        return 'Incluidos';
      default:
        return 'No incluidos';
    }
  }

  getContainers() {
    const { production } = this.props;

    if (
      {}.hasOwnProperty.call(production, 'features') &&
      production.features.length > 0
    ) {
      const containers = production.features.find(v => v.key === 'containers');
      if (containers) {
        return containers.value;
      }
    }
    return 'No especificados';
  }

  getRoyaltyLength = () => {
    const { production } = this.props;
    if (!production.royaltylength) return 'No disponible';
    return RoyaltyLengthOptions.filter(kv => kv.value === production.royaltylength)[0].label;
  }

  getSoundType = () => {
    const { production } = this.props;
    if (!production.soundtype) return 'No disponible';
    return SoundTypeOptions.filter(kv => kv.value === production.soundtype)[0].label;
  }

  getRecordType = () => {
    const { production } = this.props;
    if (!production.recordtype) return 'No disponible';
    return RecordTypeOptions.filter(kv => kv.value === production.recordtype)[0].label;
  }

  getNumberOfCameras = () => {
    const { production } = this.props;
    if (!production.numberofcameras) return 'No disponible';
    return NumberOfCamerasOptions.filter(kv => kv.value === production.numberofcameras)[0].label;
  }

  renderType = () => {
    const { production } = this.props;
    if (production.isDigital) { return `${production.type} (Digital)`; }
    if (production.type) {
      return production.type;
    }
  }

  interested = () => {
    const { history } = this.props;
    Popup.create({
      content: 'Para conocer las ofertas disponibles, debes registrarte.',
      buttons: {
        left: [
          {
            text: 'No por el momento',
            className: 'styled-button',
            action: () => Popup.close(),
          },
        ],
        right: [
          {
            text: 'Registrarme',
            className: 'styled-button',
            action: () => {
              history.push('/login');
              Popup.close();
            },
          },
        ],
      },
    });
  };

  render() {
    const { production, history, loading } = this.props;

    if (
      production &&
      {}.hasOwnProperty.call(production, 'active') &&
      !production.active
    ) {
      history.push('/404');
    }

    return (
      <div>
        <Helmet>
          <title>
            {(production && production.name) || 'Producción sin nombre'} -
            Escena Marketplace
          </title>
        </Helmet>
        <Banner />
        <div className="properties-details-page">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                <div className="properties-details-section">
                  <div className="clearfix m-b-sm">
                    <div className="pull-left">
                      <h3 className="mb-5">
                        <ReactPlaceholder
                          style={{ minWidth: 300 }}
                          showLoadingAnimation
                          rows={1}
                          type="textRow"
                          ready={!loading}
                        >
                          <div className="production-title">
                            {production.name}{' '}
                            <SaleOrRent
                              className="pl-5 inline-block"
                              value={production.saleOrRent}
                            />
                          </div>
                        </ReactPlaceholder>
                      </h3>

                      <ReactPlaceholder
                        style={{ marginTop: 5, marginBottom: 5 }}
                        showLoadingAnimation
                        rows={1}
                        type="text"
                        ready={!loading}
                      >
                        <div className="no-margin">
                          <span className="capitalize">
                            <strong>Tipo:</strong> {this.renderType()}
                          </span>
                          {production.year && production.year !== 0 ? (
                            <span>
                              {' '}
                              - <strong>Año:</strong> {production.year}
                            </span>
                          ) : (
                            ''
                          )}
                          {production.owner && (
                            <span className="capitalize">
                              {' '}
                              -<strong> Teatro/Compañia: </strong>
                              <Authorization
                                deniedPlans={[FREE_PLAN]}
                                allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
                              >
                                {production.owner.name}
                              </Authorization>
                              <Authorization allowedPlans={[FREE_PLAN]}>
                                <Lock />
                              </Authorization>
                              <Authorization allowed={['guest']}>
                                <Lock />
                              </Authorization>
                            </span>
                          )}
                        </div>
                      </ReactPlaceholder>

                      <ReactPlaceholder
                        showLoadingAnimation
                        rows={1}
                        type="text"
                        ready={!loading}
                      >
                        <div>
                          {this.getUserFeatures().map(feature => (
                            <ProductionUser
                              className="block pb-5"
                              key={feature.id}
                              value={feature}
                            />
                          ))}
                        </div>
                      </ReactPlaceholder>
                    </div>
                    <div className="pull-right m-t-lg">
                      {/* <ReactPlaceholder
                        style={{ minWidth: 70 }}
                        showLoadingAnimation
                        rows={1}
                        type="text"
                        ready={!loading}
                      >
                        <Ago time={production.createdAt} />
                      </ReactPlaceholder> */}
                      {!IsGuest() && production && production.id && (
                        <div className="favorites__wrapper">
                          <ToggleProductionFavorite
                            id={production.id}
                            favorite={production.favorite}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="table-responsive pt-10">
                    <table className="table table-striped">
                      <tbody>
                        <tr>
                          <td>Presupuesto/Budget</td>
                          <td>
                            <ReactPlaceholder
                              showLoadingAnimation
                              rows={1}
                              type="text"
                              ready={!loading}
                            >
                              <span>{`${this.getBudget()}*`}</span>
                            </ReactPlaceholder>
                          </td>
                        </tr>
                        <tr>
                          <td>Derechos/Royalties</td>
                          <td>
                            <ReactPlaceholder
                              showLoadingAnimation
                              rows={1}
                              type="text"
                              ready={!loading}
                            >
                              <span>{this.getRights()}</span>
                            </ReactPlaceholder>
                          </td>
                        </tr>
                        {!production.isDigital && (
                        <tr>
                          <td>Containers</td>
                          <td>
                            <ReactPlaceholder
                              showLoadingAnimation
                              rows={1}
                              type="text"
                              ready={!loading}
                            >
                              <span>{this.getContainers()}</span>
                            </ReactPlaceholder>
                          </td>
                        </tr>
                        )}
                        {production.isDigital && (
                          <React.Fragment>
                            <tr>
                              <td>Tipo de grabación</td>
                              <td>
                                <ReactPlaceholder
                                  showLoadingAnimation
                                  rows={1}
                                  type="text"
                                  ready={!loading}
                                >
                                  <span>{this.getRecordType()}</span>
                                </ReactPlaceholder>
                              </td>
                            </tr>
                            <tr>
                              <td>Número de cámaras</td>
                              <td>
                                <ReactPlaceholder
                                  showLoadingAnimation
                                  rows={1}
                                  type="text"
                                  ready={!loading}
                                >
                                  <span>{this.getNumberOfCameras()}</span>
                                </ReactPlaceholder>
                              </td>
                            </tr>
                            <tr>
                              <td>Grabación de Sonido</td>
                              <td>
                                <ReactPlaceholder
                                  showLoadingAnimation
                                  rows={1}
                                  type="text"
                                  ready={!loading}
                                >
                                  <span>{this.getSoundType()}</span>
                                </ReactPlaceholder>
                              </td>
                            </tr>
                            <tr>
                              <td>Tiempo de duración del Royalty o Derechos</td>
                              <td>
                                <ReactPlaceholder
                                  showLoadingAnimation
                                  rows={1}
                                  type="text"
                                  ready={!loading}
                                >
                                  <span>{this.getRoyaltyLength()}</span>
                                </ReactPlaceholder>
                              </td>
                            </tr>
                          </React.Fragment>
                        )}
                      </tbody>
                    </table>
                    <span className="price-note">* Precios referenciales</span>
                  </div>

                  {/* Features */}


                  <div className="properties-condition mrg-btm-40 ">
                    {!production.isDigital && (
                      <div className="row pt-15">
                        <ProductionFeatures
                          loading={loading}
                          features={production}
                        />
                      </div>
                    )}
                    <div className="row">
                      <Files files={this.getLinks()} />
                    </div>
                  </div>

                  <Authorization allowed={['guest', 'user']}>
                    <Button
                      className="mrg-btm-40"
                      onClick={this.interested}
                      url="/loginOrRegister"
                      value="Estoy interesado"
                      icon="fa-star"
                    />
                  </Authorization>

                  <div className="properties-description mrg-btm-40 mt-15">
                    <h3 className="heading pt-15">Descripción</h3>
                    <ReactPlaceholder
                      style={{ minWidth: 70 }}
                      showLoadingAnimation
                      rows={5}
                      type="text"
                      ready={!loading}
                    >
                      <p>{production.description}</p>
                    </ReactPlaceholder>
                  </div>

                  {production.images && (
                    <Carousel
                      id="productions-images"
                      images={production.images}
                      alt="Producciones"
                      restrict={IsGuest() || IsFreePlan()}
                    />
                  )}

                  <Authorization allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}>
                    <div className="row">
                      {this.getVideos().map(video => (
                        <div key={video.value} className="col-md-6">
                          <ReactPlayer
                            controls
                            url={video.value}
                            width="100%"
                            height="100%"
                          />
                        </div>
                      ))}
                    </div>
                  </Authorization>
                </div>
              </div>

              {production.owner && (
                <Authorization
                  deniedPlans={[FREE_PLAN]}
                  allowed={[THEATER_ADMIN_ROLE, ADMIN_ROLE]}
                >
                  <TheaterWidget theater={production.owner} />
                </Authorization>
              )}

              {production.images && production.images.length > 0 && (
                <Authorization allowed="guest">
                  <div className="col-lg-4 col-md-4 col-xs-12 mb-20">
                    <div className="sidebar right">
                      <img
                        src={production.images[0].url}
                        className="thumb-preview"
                        alt="Producción"
                      />
                    </div>
                  </div>
                </Authorization>
              )}

              <div className="col-lg-4 col-md-4 col-xs-12">
                <div className="sidebar right">
                  <ChangePlan />
                </div>
              </div>

              {production.owner && (
                <Authorization denied="guest">
                  <div className="col-lg-4 col-md-4 col-xs-12">
                    <div className="sidebar right">
                      <div className="thumbnail recent-properties-box">
                        <div className="caption detail">
                          <header className="clearfix">
                            <div className="pull-left">
                              <h1 className="title">Contacto</h1>
                            </div>
                          </header>
                          <ContactTheaterForm id={production.owner.id} />
                        </div>
                      </div>
                    </div>
                  </div>
                </Authorization>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withProduction = graphql(PRODUCTION_DETAILS_QUERY, {
  options: ({ match }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      slug: match.params.productionSlug,
    },
  }),
  props: ({ data }) => ({
    loading: data.loading,
    production: data.production,
  }),
});

ProductionPage.defaultProps = {
  production: {},
};

export default withProduction(ProductionPage);



// WEBPACK FOOTER //
// ./src/containers/General/ProductionPage/index.js